// this file is not using flow because currently there is not support for Context
// https://github.com/facebook/flow/issues/2916#issuecomment-263523543

import React from 'react';

const SidebarContext = React.createContext({
  isSidebarOpen: false,
  toggleSidebar: () => {}
});

export default SidebarContext;



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarContext/index.js